import http from "./httpService";

const endPoint = "/Files";

export function upload(file, metaData, onUploadProgress = (() => {})) {
    const data = new FormData();
    data.append("file", file);

    if(metaData){
        for(const prop in metaData){
            data.append(`metadata[${prop}]`, metaData[prop]);
        }
    }

    return http.post(endPoint, data, { 
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress
    });
}

export default { upload };